import { Injectable } from '@angular/core';
import { Config, Platform } from '@ionic/angular';
import { ITesis } from '@shared/models/interfaces';
import { Observable, of } from 'rxjs';
import { CredentialsService } from '../credentials.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(
    private credentialsService: CredentialsService,
    private platform: Platform,
    private config: Config,
  ) { }

  get currencyUnit(): string | null {
    const credentials = this.credentialsService.credentials;
    return credentials ? credentials.currencyUnit : null;
  }

  get isWeb(): boolean {
    return !this.platform.is('cordova');
  }

  get isIOS(): boolean {
    return this.config.get('mode') === `ios`;
  }

  getTesisList$(): Observable<ITesis[]> {
    return of(tesisList);
  }
}

const tesisList: ITesis[] = [
  { facId: 0, name: 'Senkron Yazılım Tesisleri', notify: 3, pic: '' },
  { facId: 1, name: 'YTU Teknopark', notify: 1, pic: '1.png' },
  { facId: 2, name: 'MaxxRoyal Belek', notify: null, pic: '2.png' },
  { facId: 3, name: 'Senyonet Demo', notify: 2, pic: '3.png' },
  { facId: 4, name: 'Tekfen Tower', notify: 1452, pic: '4.png' }
];
